import styled from 'styled-components';
import {mobileBreakPoint, FlexRow, FlexColumn} from '../../../StyledUtils';

export const StyledPopularSitesContainer = styled(FlexRow)`
  background-color: #f6f6f6;
  padding: 64px 0px; 
  width: 100%;
  align-items: center;
  @media (max-width: ${mobileBreakPoint}) {
    flex-direction: column-reverse;
    justify-content: center;
    margin-bottom: 40px;
  }
`;

export const Title = styled.div`
  font-size: 32px;
  font-weight: bold;
  color: #1b1b1b;
  line-height: normal;
  margin-bottom: 16px;
  text-align: center;
  @media (max-width: ${mobileBreakPoint}) {
      font-size: 32px;
  }
`;

export const Subtitle = styled.div`
  font-size: 20px;
  color: #808080;
  line-height: normal;
  margin-bottom: 72px;
  text-align: center;
`;

export const SiteCardsContainer = styled(FlexRow)`
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: ${mobileBreakPoint}) {
    flex-wrap: nowrap;
  }
`;
